import { FC, useMemo } from 'react';
import { upperFirst } from 'lodash';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { taskErrorSnackBarAtom } from '../../../data-access';
import { useStartTodoAuth } from '../../../hooks';
import { ReactComponent as TodoIcon } from '../../../assets/tabs/settings-tab/todo-icon.svg';
import StyledSnackBar from './StyledSnackBar';

const TaskErrorSnackBar: FC = () => {
  const { t } = useTranslation();
  const [taskErrorSnackbar, setTaskErrorSnackbar] = useRecoilState(taskErrorSnackBarAtom);
  const { handleOpenTodoAuth } = useStartTodoAuth({});

  const message = useMemo(() => {
    if (!taskErrorSnackbar) return null;
    if (taskErrorSnackbar.status === 401) {
      return t('task.error.snackbarAuthMessage', { message: taskErrorSnackbar.message });
    }
    return t('task.error.snackbarMessage', { message: taskErrorSnackbar.message });
  }, [taskErrorSnackbar, t]);

  const handleClose = () => setTaskErrorSnackbar(null);

  const showReconnect = taskErrorSnackbar?.status === 401 && !!taskErrorSnackbar?.provider;

  return (
    <StyledSnackBar
      open={!!taskErrorSnackbar}
      message={message}
      icon={<TodoIcon />}
      color="#c0392b"
      actionLabel={
        showReconnect
          ? t('task.error.reconnectProvider', {
              provider: upperFirst(taskErrorSnackbar?.provider),
            })
          : undefined
      }
      onAction={
        showReconnect ? () => handleOpenTodoAuth(taskErrorSnackbar?.provider) : undefined
      }
      onClose={handleClose}
      autoHideDuration={null}
      closeAriaLabel={t('task.common.close')}
    />
  );
};

export default TaskErrorSnackBar;
